import { render } from "./BannerDownloadApp.vue?vue&type=template&id=5b331cd2"
import script from "./BannerDownloadApp.vue?vue&type=script&lang=js"
export * from "./BannerDownloadApp.vue?vue&type=script&lang=js"

import "./BannerDownloadApp.vue?vue&type=style&index=0&id=5b331cd2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__